import { render } from "./AlignPanel.vue?vue&type=template&id=76519540&scoped=true"
import script from "./AlignPanel.vue?vue&type=script&lang=js"
export * from "./AlignPanel.vue?vue&type=script&lang=js"

import "./AlignPanel.vue?vue&type=style&index=0&id=76519540&scoped=true&lang=css"

import exportComponent from "D:\\ASMPP\\ASMPP_VUE\\asmpp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76519540"]])

export default __exports__